import React, { Component } from "react";
import "./ScrollProgressIndicator.scss";

class ScrollProgressIndicator extends Component {
  componentDidMount() {
    if (document) document.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    if (document) document.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;
    const height =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;
    const scrolled = (winScroll / height) * 120;

    document.getElementById("myBar").style.width = scrolled + "%";
  };

  render() {
    return (
      <div className="progress-container">
        <div className="progress-bar" id="myBar" />
      </div>
    );
  }
}

export default ScrollProgressIndicator;



// WEBPACK FOOTER //
// ./application/components/ScrollProgressIndicator/ScrollProgressIndicator.jsx